import React from "react";

const Work = () => (
  <div className="row work">
    <div className="three columns header-col">
      <h1>
        <span>Experience</span>
      </h1>
    </div>

    <div className="nine columns main-col">
      <div className="row item">
        <div className="twelve columns">
          <h3><a href="https://xxxlesnina.si">Lesnina XXXL</a></h3>
          <p className="info">
            Online Project Manager
            <span>&bull;</span>
            <em className="date">July 2017 - Present</em>
          </p>
            <ul className="disc">
              <li>
                Executed hundreds of email campaigns with KPI - s surpassing the industry benchmarks.
              </li>
              <li>
                Planned and implemented transactional emails with reporting.
              </li>
              <li>
                Set up automatic reporting systems.
              </li>
              <li>
                Developed custom web elements.
              </li>
              <li>
                Planned and executed the GDPR compliance measures.
              </li>
            </ul>
          

          
        </div>
      </div>

      <div className="row item">
        <div className="twelve columns">
          <h3><a href="https://lu.mu">Lumulabs</a></h3>
          <p className="info">
            Communications Officer
            <span>&bull;</span>
            <em className="date">2016 - 2017</em>
            </p>
            <ul className="disc">
              <li>
                Nurtured the Kickstarter backer community.
              </li>
              <li>
                Developed marketing and communication strategies.
              </li>
              <li>
                Planned and delivered web redesigns.
              </li>
              <li>
                Delivered customer support to the users.
              </li>
            </ul>
          
            
        </div>
      </div>

            <div className="row item">
        <div className="twelve columns">
          <h3> <a href = "https://www.eurosender.com/" >Eurosender</a></h3 >
          <p className="info">
            Email Marketing Manager
            <span>&bull;</span>
            <em className="date">2016</em>
            </p>
            <ul className="disc">
              <li>
                Planned and set up lead generation systems.
              </li>
              <li>
                Tasked with generating new sales through existing client base.
              </li>
              <li>
                Refined the marketing funnel.
              </li>
              <li>
                Administered the CRM database.
              </li>
            </ul>
         
           
        </div>
      </div>


      <div className="row item">
        <div className="twelve columns">
          <h3> <a href = "https://www.petrol.si/" >Petrol</a></h3 >
          <p className="info">
          Email Marketing Manager
            <span>&bull;</span>
            <em className="date">2014 - 2016</em>
            </p>
            <ul className="disc">
            <li>Planned, executed and analyzed hundreds of email marketing campaigns.</li>
            <li>Took part in omnichannel synchronization. </li>
            <li>Designed and developed email HTML templates.</li>
            </ul>         
          
           

           <p className="info">
           Web Editor, UX consultant
            <span>&bull;</span>
            <em className="date">2013 - 2016</em>
            </p>
            <ul className="disc">
            <li>Generated content for the web.</li>
            <li>Advocated web users.</li>
            <li>Carried out a couple of web and mobile development projects.</li>
            <li>Moderated web content to align with good UX practices.</li>
            <li>Developed web components.</li>
            </ul>
            
        </div>
      </div>

      
    </div>
  </div>
);

export default Work;



// WEBPACK FOOTER //
// ./src/components/Work.js